import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";
import { formatChurnRate } from "../../../../utils/formatChurnRate";

const ChurnRatePercent = ({ qa }) => {
  const { value, churnRate, tooltip, churnRateChange, valueChange } = useSelector(
    (state) => state.membershipUnits.membershipUnits.churnRate
  );

  const actualValue = formatChurnRate(value || churnRate);

  return (
    <SectionContainer
      title="Attrition Rate"
      toolTip={tooltip}
      toolTipId="membershipChurnRateToolTip"
      isToolTipHtml
    >
      <DataDisplay
        type="percentage"
        showDecimal
        toFixedValue={actualValue > 0 ? 2 : undefined}
        value={actualValue}
        disableAnimation={qa}
        toolTipContent={tooltip}
        toolTipId="membershipChurnRateToolTip"
        changeProps={{
          changeValue: churnRateChange || valueChange,
          toolTip: "Percentage change from previous month",
          showBorder: true,
          positiveColor: "#c7343e",
          negativeColor: "#21e981"
        }}
      />
    </SectionContainer>
  );
};

export default ChurnRatePercent;
